import React, { useState } from 'react';
import { Control, FieldValues, UseControllerProps } from 'react-hook-form';
import { BaseFieldProps } from 'redux-form';
import TextInputField, { TextInputHookForm } from '../text/text';
import { TextInputOwnProps } from '../text/text-input';
import { Button } from '@common/components/button';

const PASSWORD_INPUT_CLASS_NAME = '!tw-w-[calc(100%-32px-32px-2px)] !tw-pr-12 !tw-bg-[right_40px_center]';

function PasswordVisibilityToggle({
  showPassword,
  onToggle,
}: {
  showPassword: boolean;
  onToggle: () => void;
}) {
  return (
    <div
      className="tw-absolute tw-right-0 tw-top-0 tw-flex
      tw-items-center tw-justify-center tw-w-12 tw-h-9"
    >
      <Button
        icon={showPassword ? 'visibility_off' : 'visibility'}
        onClick={onToggle}
        className="password-input-toggle-button !tw-bg-transparent"
      />
    </div>
  );
}

const PasswordInput = React.forwardRef<HTMLInputElement | undefined, BaseFieldProps & TextInputOwnProps>(
  (props, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    return (
      <div className="tw-relative password-input-wrapper">
        <TextInputField
          {...props}
          type={showPassword ? 'text' : 'password'}
          className={PASSWORD_INPUT_CLASS_NAME}
          ref={ref}
        />
        <PasswordVisibilityToggle
          showPassword={showPassword}
          onToggle={togglePasswordVisibility}
        />
      </div>
    );
  });

export function PasswordInputHookForm<T extends FieldValues>(
  props: Omit<TextInputOwnProps, 'ref'> & UseControllerProps<T> & { control: Control<T> },
) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="tw-relative password-input-wrapper">
      <TextInputHookForm
        {...props}
        type={showPassword ? 'text' : 'password'}
        className={PASSWORD_INPUT_CLASS_NAME}
      />
      <PasswordVisibilityToggle
        showPassword={showPassword}
        onToggle={() => setShowPassword((current) => !current)}
      />
    </div>
  );
}

export default PasswordInput;
